
export class ProviderInstanceProfileCountryModel {
  providerId: string;
  providerInstanceId: string;
}
